var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacetedRadiant(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    id: "dia-faceted-radiant",
    viewBox: "19 16 54 54",
    width: 100,
    height: 100,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    id: "bg-fill_33_",
    d: "M67.5 21.1V21v-.1-.1-.1-.1s0-.1-.1-.1l-.1-.1s0-.1-.1-.1l-4.8-4.1s-.1 0-.1-.1h-.1-.1-.1-.1-31.6-.1-.1-.1-.1-.1s-.1 0-.1.1l-4.8 4.1-.1.1-.1.1s0 .1-.1.1V64.6s0 .1.1.1l.1.1s0 .1.1.1l4.8 4.1H62.2s.1 0 .1-.1h.1l4.8-4.1.1-.1.1-.1s0-.1.1-.1v-.1-.1-.1-.1-43z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "shadow_33_",
    fill: "currentColor",
    fillOpacity: 0.085,
    d: "M37.4 55c-8.4-12.1-8.6-30.4-8.3-38.2l-4.2 3.6-.1.1-.1.1s0 .1-.1.1V64.7s0 .1.1.1l.1.1s0 .1.1.1l4.8 4.1H62.2s.1 0 .1-.1h.1l3.7-3.2c-6.3.9-20.4 1.2-28.7-10.8z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "stroke_32_",
    fill: "currentColor",
    d: "M67.5 21.1V21v-.1-.1-.1-.1s0-.1-.1-.1l-.1-.1s0-.1-.1-.1l-4.8-4.1s-.1 0-.1-.1h-.1-.1-.1-.1-31.6-.1-.1-.1-.1-.1s-.1 0-.1.1l-4.8 4.1-.1.1-.1.1s0 .1-.1.1V64.6s0 .1.1.1l.1.1s0 .1.1.1l4.8 4.1H62.2s.1 0 .1-.1h.1l4.8-4.1.1-.1.1-.1s0-.1.1-.1v-.1-.1-.1-.1-43zM46 60.1l-10.8-.7-.8-16.7.8-16.7 10.8-.8 10.8.7.8 16.7-.8 16.7-10.8.8zm11.8-34.6l3.7-1.4-3.1 15.5-.6-14.1zm-.6-.5l-9.1-.6 10.3-3.1-1.2 3.7zm-22.3 0l-1.2-3.7 10.3 3-9.1.7zm-1.3 14.6l-3.1-15.5 3.7 1.4-.6 14.1zm-.1 2v2l-3 15.4V26.2l3 15.4zm.1 4.1l.6 14-3.7 1.4 3.1-15.4zm1.3 14.6l9.1.6L33.7 64l1.2-3.7zm22.3 0l1.2 3.7-10.3-3.1 9.1-.6zm1.2-14.6l3.1 15.5-3.7-1.4.6-14.1zm.1-2.1v-2l3-15.4V59l-3-15.4zM57.7 25l1.2-3.7 2.5 2.3-3.7 1.4zm-11-.7h-1.2L35 21.1h22.1l-10.4 3.2zm-12.3.7l-3.7-1.4 2.5-2.3 1.2 3.7zM30 61.4l-3.5 1.9V21.9l3.5 1.9v37.6zm4.4-1.2L33.2 64l-2.5-2.3 3.7-1.5zm11 .8h1.2L57 64.1H35L45.4 61zm12.3-.8l3.7 1.4-2.5 2.4-1.2-3.8zm4.4-36.4l3.5-1.9v41.4l-3.5-1.9V23.8zm-.2-.4l-2.8-2.6 2.2-2.8h.1l4.1 3.5-3.6 1.9zm-3.3-2.8H33.4l-2-2.6h29.2l-2 2.6zM30.7 18l2.2 2.8-2.8 2.6-3.5-1.9 4.1-3.5zm-.5 43.9l2.8 2.6-2.2 2.8h-.1l-4.1-3.5 3.6-1.9zm3.2 2.8h25.2l2 2.6H31.4l2-2.6zm27.9 2.6l-2.2-2.8 2.8-2.6 3.5 1.9-4.1 3.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacetedRadiant);
export default __webpack_public_path__ + "static/media/faceted-radiant.86f7a950e582c2972b59e4dd41145ca2.svg";
export { ForwardRef as ReactComponent };